/**
 * 3D全景接口
 */
import request from '../request'

const URL = {
  findPageWithAuthority: '/memorabilia/findPageWithAuthority', // 分类事记列表
  findMemorabiliaListByReceive: '/memorabilia/findMemorabiliaListByReceive', // 历史上的今天
  findById: '/memorabilia/findById/', // 新闻详情
}

const news = {
  /**
  * 历史上的今天
  * @param {object} reqData  请求参数
  */
  findMemorabiliaListByReceive (reqData) {
    return request.put(URL.findMemorabiliaListByReceive, reqData)
  },
  // 分类事记列表
  findPageWithAuthority (reqData) {
    return request.put(URL.findPageWithAuthority, reqData)
  },
  // 事记详情
  findById (id) {
    return request.get(`${URL.findById}/${id}?_dt=${new Date().getTime()}`)
  },
}
export default news
